import { useQuery } from '@tanstack/react-query';
import { getTaxonomyTags } from 'api/taxonomyTags';
import { TaxonomyTag } from 'interfaces/taxonomyTag';
import { filter, some } from 'es-toolkit/compat';
import { useMemo } from 'react';

const useTaxonomyTags = (path?: string) => {
  const query = useQuery<TaxonomyTag[]>({
    queryKey: ['taxonomyTags'],
    queryFn: ({ signal }) => getTaxonomyTags(signal),
  });

  const relevantTaxonomyTags = useMemo(() => {
    if (!path) return query?.data;
    return filter(query?.data, (tag) => some(tag?.labels, (label) => path == label || path.startsWith(`${label}.`)));
  }, [path, query?.data]);

  return { ...query, data: relevantTaxonomyTags };
};

export default useTaxonomyTags;
